import React from 'react';

import BannerStore from './stores/BannerStore';
import Banner from './components/Banner';

function AlertBanner(props) {
  const store = new BannerStore(props);

  return <Banner store={store} />;
}

export default AlertBanner;
